import { Center, Spinner } from "@leplein/ui";

export const Loader = () => (
	<Center className="flex-1">
		<Spinner size="large" color="white" />
	</Center>
);
